export const PALETTE_HEX: [string, string, string][] = [
	['#E24F1A', '#6F9BB0', '#1E3C64'],
	['#FF6B35', '#F6AE2D', '#0F4C5C'],
	['#FF5F6D', '#A8C0FF', '#2B3A67'],
	['#F98F39', '#9AD0EC', '#2E4A62'],
	['#FF8E72', '#56CFE1', '#1D2D50'],
	['#F45B69', '#A0C4FF', '#2F3E9E'],
	['#EA5939', '#8FD5FF', '#1F375B'],
];

